module.exports = __webpack_public_path__ + "static/media/logo_etime.14cd2330.svg";